import { withWindow } from '@shared/utils/withWindow';

export interface GeneratePartnerLinkParams {
  eventId?: string | null;
  googleId?: string | null;
  zhId?: string | null;
  hotelWebsite?: string | null;
  location?: { lat: number; lng: number };
  name?: string | null;
  address?: string | null;
  ignoreAvailability?: boolean;
}

export enum PartnerLinkSearchParams {
  googlePlaceId = 'gplid',
  hotelWebsite = 'hotelWebsite',
  latitude = 'lat',
  longitude = 'lng',
  name = 'name',
  address = 'address',
  idType = 'idType',
  source = 'source',
  ignoreAvailability = 'ignoreAvailability',
}

export const useHotelBookingPartnerLink = () => {
  const generateHotelUrl = ({ address, googleId, hotelWebsite, location, name, zhId, ignoreAvailability }: GeneratePartnerLinkParams): URL | undefined => {
    return withWindow<URL | undefined>(window => {
      const destination = new URL(window.location.origin);
      destination.pathname = `/hotel/${zhId || ''}`;

      // Add hotel website
      if (hotelWebsite) {
        destination.searchParams.set(PartnerLinkSearchParams.hotelWebsite, hotelWebsite);
      }

      // Add Google props
      if (googleId) {
        destination.searchParams.set(PartnerLinkSearchParams.googlePlaceId, googleId);
      } else if (name && address) {
        destination.searchParams.set(PartnerLinkSearchParams.name, name);
        destination.searchParams.set(PartnerLinkSearchParams.address, address);
      } else if (location) {
        destination.searchParams.set(PartnerLinkSearchParams.latitude, location.lat.toString());
        destination.searchParams.set(PartnerLinkSearchParams.longitude, location.lng.toString());
      }

      // Add ignore availability
      if (ignoreAvailability) {
        destination.searchParams.set(PartnerLinkSearchParams.ignoreAvailability, 'true');
      }
      return destination;
    }, undefined);
  };

  const generateUrlPartnerLink = (args: GeneratePartnerLinkParams): string | undefined => {
    if (!args.eventId) {
      return;
    }

    return withWindow<string | undefined>(window => {
      const destination = generateHotelUrl(args);
      if (!destination) return;

      const url = new URL(window.location.origin);
      url.pathname = `/eventredirect/${args.eventId}`;
      url.searchParams.set('destination', destination.pathname + destination.search);
      return url.toString();
    }, undefined);
  };

  const generateHotelId = (googleId?: string, zhId?: string) => {
    return zhId ? `g-${googleId}&z-${zhId}` : googleId || '';
  };

  return { generateUrlPartnerLink, generateHotelId, generateHotelUrl };
};
